
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

export const Logo = ({ className }: LogoProps) => {
  return (
    <div className={cn("text-xl font-display font-bold tracking-tight flex items-center gap-1", className)}>
      <span className="text-gray-800 text-2xl">Indirect</span>
      <span className="text-purple-vivid">Cheats</span>
    </div>
  );
};
